'use strict'

const getBookieData = async () => {
  if (window.localStorage.getItem('bbbSportsbooks')) {
    return JSON.parse(window.localStorage.getItem('bbbSportsbooks'))
  }

  const bookies = await fetchBookies()

  const map = await Promise.all(bookies.map(async (bookie) => {
    const sports = {
      percentage: bookie.acf.listing_sports_bonus.percentage,
      upperLimit: bookie.acf.listing_sports_bonus.amount,
      code: bookie.acf.listing_sports_bonus.code,
      minDeposit: bookie.acf.listing_sports_bonus.min_deposit,
      rollover: bookie.acf.listing_sports_bonus.rollover,
      additional: bookie.acf.listing_sports_bonus.additional,
      initialDepositOnly: bookie.acf.listing_sports_bonus.initial_deposit_only,
    }
    const casino = {
      percentage: bookie.acf.listing_casino_bonus.percentage,
      upperLimit: bookie.acf.listing_casino_bonus.amount,
      code: bookie.acf.listing_casino_bonus.code,
      minDeposit: bookie.acf.listing_casino_bonus.min_deposit,
      rollover: bookie.acf.listing_casino_bonus.rollover,
      additional: bookie.acf.listing_casino_bonus.additional,
      initialDepositOnly: bookie.acf.listing_casino_bonus.initial_deposit_only,
    }
    const affLink = bookie.acf.aff_link
    const logoUrl = await fetchBookieLogo(bookie.acf.logo)
    const slug = bookie.slug.split('-')[0]
    return {
      slug, sports, casino, affLink, logoUrl
    }
  }))

  const data = {}
  map.forEach(bookie => {
    data[bookie.slug] = bookie
  })

  const sportsbooks = Object.fromEntries(
    Object.entries(data).sort(([, a], [, b]) => {
      return b.sports.percentage - a.sports.percentage
    })
  )

  window.localStorage.setItem('bbbSportsbooks', JSON.stringify(sportsbooks))

  return sportsbooks
}

const fetchBookies = async () => {
  const url = `${BBB.restUrl}review`
  return window.fetch(url)
    .then(response => response.json())
    .then(data => data)
}

const fetchBookieLogo = async (id) => {
  const url = `${BBB.restUrl}media/${id}`
  const response = await window.fetch(url)
  const data = await response.json()
  return data.guid.rendered
}

const currency = (number, fractionDigits = 0) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: fractionDigits
  }).format(number)
}

const makeDomElement = (tag, html = '', className = '', ariaLabel = '') => {
  const el = document.createElement(tag)

  if (className) el.classList.add(className)
  if (html) el.innerHTML = html
  if (ariaLabel) el.setAttribute('aria-label', ariaLabel)

  return el
}

const appendToDom = (parent, child) => {
  parent.innerHTML = ''
  parent.appendChild(child)
}

const showElement = (el, content) => {
  el.classList.remove('hidden')
  if (content) el.innerHTML = content
}

const hideElement = (el, removeContent = true) => {
  el.classList.add('hidden')
  if (removeContent) el.innerHTML = ''
}

const showError = (el) => el.classList.add('has-errors')
const removeError = (el) => el.classList.remove('has-errors')

const $$ = (sel) => document.querySelectorAll(sel)

export { getBookieData, fetchBookies, currency, makeDomElement, appendToDom, showElement, hideElement, showError, removeError }
